import React from 'react';

const PasswordStrengthIndicator = ({ passwordStrength }) => (
  <div className="space-y-2">
    <div className="flex items-center justify-between">
      <span className="text-sm text-gray-400">Password Strength:</span>
      <span className={`text-sm font-semibold ${passwordStrength.color}`}>{passwordStrength.label}</span>
    </div>
    <div className="h-2 bg-gray-700 rounded-full overflow-hidden">
      <div className={`h-full transition-all ${
        (() => {
          if (passwordStrength.score === 1) return 'bg-red-600 w-1/4';
          if (passwordStrength.score === 2) return 'bg-orange-600 w-2/4';
          if (passwordStrength.score === 3) return 'bg-yellow-600 w-3/4';
          return 'bg-green-600 w-full';
        })()
      }`} />
    </div>
    <div className="grid grid-cols-2 gap-2 text-xs">
      {[
        ['length', '8+ characters'],
        ['uppercase', 'Uppercase'],
        ['lowercase', 'Lowercase'],
        ['number', 'Number'],
        ['special', 'Special character'],
      ].map(([key, label]) => (
        <div key={key} className={passwordStrength.checks[key] ? 'text-green-500' : 'text-gray-500'}>
          {'\u2713'} {label}
        </div>
      ))}
    </div>
  </div>
);

export default PasswordStrengthIndicator;
